import { loginAction, updateAccountDetail } from '@avantia/azure-ad-auth';
import { useMsal } from '@azure/msal-react';
import { azureAdAuthSuccessAction } from 'actions/azureAdAuthSuccessAction';
import { getCustomerInsuranceSummaryAction } from 'actions/getCustomerInsuranceSummaryAction';
import { log } from 'clientLogging';
import { getConfig } from 'config/configuration';
import { AUTH_TYPE } from 'interfaces/authTypes';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { getAgentSearchParams } from 'storage/agentSearch';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { isAgentLogin } from './isAgentLogin';
import { processAuthLink } from './processAuthLink';

const { websiteBaseUrl } = getConfig();

export const useAgentAuthentication = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const history = useHistory();
  const authentication = useAppSelector((state) => state.authentication);
  const { name: userName, isAgentAuthenticatedOrCustomer } = authentication;
  const { instance, accounts, inProgress } = useMsal();
  const account = accounts[0] || undefined;

  useEffect(() => {
    if (!isAgentAuthenticatedOrCustomer && !isAgentLogin()) {
      dispatch(azureAdAuthSuccessAction());
    }
  }, [isAgentAuthenticatedOrCustomer, dispatch]);

  useEffect(() => {
    if (isAgentAuthenticatedOrCustomer || inProgress !== 'none') {
      return;
    }

    if (isAgentLogin()) {
      if (!account) {
        if (inProgress === 'none' || !isAgentAuthenticatedOrCustomer) {
          loginAction({ instance, websiteBaseUrl, type: 'redirect', acquireType: 'popup' })(dispatch);
        }
      } else {
        if (userName !== account.name) {
          updateAccountDetail({ account, dispatch, instance, websiteBaseUrl, acquireType: 'popup' })
            .then(() => {
              dispatch(azureAdAuthSuccessAction(account));
              const { path } = processAuthLink(pathname);
              const searchParams = getAgentSearchParams() || '';
              path ? history.replace(`/${path}${searchParams}`) : history.replace(`/dashboard${searchParams}`);
              dispatch(getCustomerInsuranceSummaryAction({ urlAuthType: AUTH_TYPE.AGENT }));
            })
            .catch((err) => {
              log.error().err(err).str('pathname', pathname).msg('Failed to update account details');
            });
        }
      }
    }
  });
};
